import { createSelector } from "@reduxjs/toolkit";
import {
  IActivityHistoryDiagnosticsFilter,
  IActivityHistoryFilter,
  IDiagnosticWithRelations,
  isDiagnosticFilter,
} from "../model";
import { activityHistoryFiltersSelector } from "../selectors";

export const diagnosticFilterSelector = createSelector(activityHistoryFiltersSelector, (filters: IActivityHistoryFilter[]) =>
  filters.find(isDiagnosticFilter),
);

export const diagnosticFilterEnabledValuesSelector = createSelector(
  diagnosticFilterSelector,
  (filter: IActivityHistoryDiagnosticsFilter) => filter?.enabledValues || [],
);

export const areDiagnosticFiltersActive = createSelector(
  diagnosticFilterEnabledValuesSelector,
  (filters) => !!filters.length,
);
